import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["filters"]

  initialize(){
    const { filters } = this.filtersTarget.dataset;
    this.renderFilters( JSON.parse(filters) )
    Weglot.initialize({
      api_key: atob(window.WEGLOT_API_KEY)
    });
  }

  renderFilters(filters){
    let pendingArchive = false
    $("#first-and").toggle(filters.length >= 2);

    filters.forEach((filter, index) => {
      const { filter_type, search_value } = filter;
      if (filter_type === "archived_at") {
        pendingArchive = search_value === 'has any value';
        return true
      }

      const filterText = this.getFilterText(filter, pendingArchive);
      if (!filterText) return;

      let filterHtml = this.generateFilterHtml(filter, filterText, index);
      if(index > 1)
        filterHtml = `<span class="filter-text">and</span>` + filterHtml
      $("#filter-summary").append(filterHtml);
    })

    // 4. Cleanup UI
    $("[data-controller=render-filters]").remove();
    feather.replace();
  }

  getFilterText(filter, pendingArchive){
      const { filter_type, search_field, search_value, query_type } = filter;
      
      const subscribed = search_value === "true" ? "" : "not ";
      const span = `<span class="search-field">${search_field}</span>`;

      // Map types to simple lookup strategies
      const filterMap = {
        location:             span + " is " + this.getOptionLabelValue(search_value, "location_name"),
        guest_tag:            span + " is " + this.getOptionLabelValue(search_value, "tag-name"),
        form:                 span + " is " + this.getOptionLabelValue(search_value, "form_name"),
        gender:               span + " is " + search_value,
        "continuously-sent":  span + " is " + search_value,
        provider:             this.span("Login Method") + " is " + search_value,
        rating:               `${ this.span("Rating") } is ${ search_value } stars`,
        review:               `${ this.span("Rating") } is ${ search_value } stars`,
        is_subscribed:        `${ this.span("Guest") } is ${ subscribed } subscribed`,
        sms_subscribed:       `${ this.span("SMS") } is ${ subscribed } subscribed`,
      };

      if(filterMap[filter_type])
        return filterMap[filter_type]

      const label = $(`.filter[data-search-field="${search_field}"]`).text() || search_field;

      switch (filter_type) {
        case "blast":
        case "interaction":
        case "bounce-blast":
        case "complaint-blast":
        case "bounce-interaction":
        case "complaint-interaction":
          const campaign = filter_type.includes("blast") ? "blast-name" : "interaction-name";
          return span + " is " + this.getOptionLabelValue(search_value, campaign);

        case "platform":
          const platform = ["google", "facebook", "tripadvisor", "yelp"].includes(search_value) ? search_value : "Beambox";
          return `${ this.span("Platform") } is ${ platform }`;

        case "duration-range":
          return label + this.formatFilterDate(filter.start_date) + " to " + this.formatFilterDate(filter.end_date);

        case "birthday":
        case "last visit":
        case "first visit":
          if(!["is unknown", "has any value"].includes(query_type)) {
            const suffix = query_type.includes("hours") ? "hours ago" : (query_type.includes("future") ? "days from now" : "days ago");
            const query = query_type.replace(/ hours| future/g, "");
            return span + " " + query + " " + search_value + " " + suffix ;
          }
          else
            return span + " " + query_type

        case "is_archived":
          let text = "Archived"
          if (query_type === 'false' && pendingArchive)
              text = "Pending Archived";
          return this.span(text) + " Guests";

        default:
          const value = ["is unknown", "has any value"].includes(query_type) ? "" : ` ${search_value}`;
          const suffix = filter_type === "date" ? " days ago" : "";
          return label + " " + query_type + " " + value + " " + suffix;
      }
  }

  generateFilterHtml(filter, filterText, index) {
    const { filter_type } = filter;
    let { cacheKey } = this.element.dataset;
    let { renderUrl, targetController: controller } = this.filtersTarget.dataset;

    controller = (controller === "reviews--filter-reviews") ? controller : "guest-database--filter-guests"

    const icon = `<i data-feather="filter" stroke-width="2" width="14" height="14" class="m-r-5" style="vertical-align:middle;position:relative;top:-1px;"></i>`;
    const removeIcon = `<span class="remove-mask"><i data-feather="x" stroke-width="2" width="20" height="20" class="p-r-1 remove-mask-icon"></i></span>`;
    const commonAttributes = `data-controller="${controller}" data-render-url="${renderUrl}" data-cache-key="${cacheKey}" data-array-position="${index}"`;

    switch (filter_type) {
        case "is_archived":
            return `<div class="btn applied-filter" ${commonAttributes}>${icon}${filterText}</div>`;

      case "continuously-sent":
            return `<div class="btn applied-filter">
                      <span class="new-tag">New</span>
                      <div ${commonAttributes} data-action="click->${controller}#removeFilter">
                        ${icon}${filterText}${removeIcon}
                      </div>
                    </div>`

      default:
        return `<div ${commonAttributes} data-action="click->${controller}#removeFilter" class="btn applied-filter">
                  ${icon}${filterText}${removeIcon}
                </div>`
    }
  }

  getOptionLabelValue(search_value, dataAttribute) {
    return $(`#filter_option_${search_value}`).closest('label').data(dataAttribute);
  }

  span (text) {
    return `<span class="search-field">${text}</span>`
  }

  formatFilterDate(date){
    let options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    };
    return new Date(date).toLocaleDateString(undefined, options);
  }

}
